export default "__VITE_ASSET__68a8672c__"